<div class="statcard">
    <div class="card-main">
        <div class="card-main-title">
          <mat-icon fontSet="fa" [fontIcon]="icon"></mat-icon>
          <div class="card-main-text"[innerHTML]="label"></div>
        </div>
    </div>
    <div class="sublabel" *ngIf="sublabel" [innerHTML]="sublabel"></div>
</div>